import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  TicketAction, 
  setIsFetching, 
  setFetchFailed,
  setTicketSummary,
  setTicketNotFound, 
} from 'Pages/TicketPage/Redux/actions';
import moment from 'moment';

export const fetchTicketSummary = (orderID: number, barcode: string) => {
  return async (dispatch: Dispatch<TicketAction>): Promise<void> => {
    const { isFetching } = Store.getState().ticket;

    if (!orderID || !barcode || isFetching) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('Ticket', `orderID=${ orderID }&barcode=${ barcode }`);
      const ticketSummary: Julius.Website.TicketSummaryViewModel = await response.json();
      
      if (response.status === 200) {
        ticketSummary.performanceDate = moment(ticketSummary.performanceDate).toDate();
        dispatch(setTicketSummary(ticketSummary));
      } else {
        dispatch(setTicketNotFound());
      }
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/pages/TicketPage/Redux/thunks.tsx